import { ReportsFilterOption, ReportsKpiMetric } from '@dataTypes/reports.type'

export const REVENUE_REALIZATION_FILTERS: ReportsFilterOption[] = [
  { id: 'period-category', label: 'Latest Data' },
  { id: 'period-preset', label: 'This Month' },
  { id: 'provider-filter', label: 'All Providers' },
]

export const REVENUE_REALIZATION_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'currency' | 'percent'
}> = [
  {
    id: 'total-production',
    title: 'Total Production',
    footer: 'Sum of production amount',
    format: 'currency',
  },
  {
    id: 'total-collections',
    title: 'Total Collections',
    footer: 'Sum of payments amount',
    format: 'currency',
  },
  {
    id: 'net-collection',
    title: 'Net Collection',
    footer: 'Collections divided by production',
    format: 'percent',
  },
  {
    id: 'gross-collection',
    title: 'Gross Collection',
    footer: 'Divided by production + adjustment',
    format: 'percent',
  },
  {
    id: 'same-day-collections',
    title: 'Same-Day Collections',
    footer: 'Payments collected on day of visit',
    format: 'currency',
  },
  {
    id: 'adjustment-rate',
    title: 'Adjustment Rate',
    footer: 'Adjustments divided by production',
    format: 'percent',
  },
]

export const INSURANCE_PIE_COLOR = 'var(--blue-400)'
export const PATIENT_PIE_COLOR = 'var(--orange-300)'

/** @deprecated Use REVENUE_REALIZATION_KPI_DEFINITIONS with live API values */
export const REVENUE_REALIZATION_KPI_METRICS: ReportsKpiMetric[] =
  REVENUE_REALIZATION_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))
